import React, { Component } from 'react';
import Panel from '../../../../components/angle/Panel';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../components/Spinner';
import TrustListGrid from './TrustListGrid';
import PortfolioListGrid from './PortfolioListGrid';
import ClassListGrid from './ClassListGrid';

import { fetchAllClientInformationData } from '../../../../services/redux/employee/clientInformation/actions';
import {
    fetchTrustByClient,
    fetchTrustData
} from '../../../../services/redux/employee/trust/actions';
import {
    fetchPortfolioData,
    fetchPortfolioByTrust
} from '../../../../services/redux/employee/portfolio/actions';
import {
    fetchPendingTrusts,
    updateEditPendingTrustPayload,
    fetchPendingPortfolios,
    updateEditPendingPortfolioPayload,
    fetchPendingClasses,
    updateEditPendingClassPayload
} from '../../../../services/redux/employee/security/actions';
import { Tab, Tabs } from 'react-bootstrap';

class PendingSecurities extends Component {
    componentDidMount() {
        let {
            fetchPendingTrusts,
            fetchPendingPortfolios,
            fetchPendingClasses
        } = this.props;
        fetchPendingTrusts();
        fetchPendingPortfolios();
        fetchPendingClasses();
    }

    reviewPendingTrust = selected => {
        let {
            fetchAllClientInformationData,
            history,
            updateEditPendingTrustPayload
        } = this.props;

        fetchAllClientInformationData();
        updateEditPendingTrustPayload(selected);
        history.push('/edit-pending-trust');
    };

    reviewPendingPortfolio = selected => {
        let {
            fetchTrustData,
            fetchTrustByClient,
            history,
            updateEditPendingPortfolioPayload
        } = this.props;

        fetchTrustData(selected.trustId).then(response => {
            if (response) {
                fetchTrustByClient(response.clientId);
            }
        });
        updateEditPendingPortfolioPayload(selected);
        history.push('/edit-pending-portfolio');
    };

    reviewPendingClass = selected => {
        let {
            history,
            fetchPortfolioData,
            fetchPortfolioByTrust,
            updateEditPendingClassPayload
        } = this.props;

        fetchPortfolioData(selected.portfolioId).then(response => {
            if (response) {
                fetchPortfolioByTrust(response.trustId);
            }
        });
        updateEditPendingClassPayload(selected);
        history.push('/edit-pending-class');
    };

    render() {
        let { security } = this.props;
        return (
            <div role="tabpanel" className="panel">
                <Tabs defaultActiveKey={security.activeTabKey} id="tabID">
                    <Tab eventKey={1} title="Trust">
                        <Panel showHeader header="Pending Trusts">
                            <TrustListGrid
                                dataList={security.pendingTrusts}
                                singleSelection={false}
                                handleButtonClick={this.reviewPendingTrust}
                            />
                        </Panel>
                    </Tab>
                    <Tab eventKey={2} title="Portfolio">
                        <Panel showHeader header="Pending Portfolios">
                            <PortfolioListGrid
                                dataList={security.pendingPortfolios}
                                singleSelection={false}
                                handleButtonClick={this.reviewPendingPortfolio}
                            />
                        </Panel>
                    </Tab>
                    <Tab eventKey={3} title="Class">
                        <Panel showHeader header="Pending Classes">
                            <ClassListGrid
                                dataList={security.pendingClasses}
                                singleSelection={false}
                                handleButtonClick={this.reviewPendingClass}
                            />
                        </Panel>
                    </Tab>
                </Tabs>
                {security.fetching && <Spinner />}
            </div>
        );
    }
}
const mapStateToProps = state => ({
    security: state.employee.security
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchAllClientInformationData,
            fetchTrustByClient,
            fetchTrustData,
            fetchPortfolioData,
            fetchPortfolioByTrust,
            fetchPendingTrusts,
            updateEditPendingTrustPayload,
            fetchPendingPortfolios,
            updateEditPendingPortfolioPayload,
            fetchPendingClasses,
            updateEditPendingClassPayload
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(PendingSecurities));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/PendingSecurities/index.js